import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TableList from '../../components/TableList';
import * as WorkOrderActionType from '../constants';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'ascending'
};

class BackChargeList extends React.Component {
  static propTypes = {
    ManageBackCharges: PropTypes.any,
    match: PropTypes.object,
    dispatch: PropTypes.func,
    purchaseOrderId: PropTypes.any,
    rfsId: PropTypes.any,
    isPunchList: PropTypes.bool
  };

  static defaultProps = {
    ManageBackCharges: []
  };

  constructor(props) {
    super(props);

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder // default sort order,
    };
  }

  componentDidMount() {
    this.fetchBCList({
      sortField: 'refNo',
      sortOrder: 'ascending',
      PoRefNo: this.props.purchaseOrderId
    });
  }

  fetchBCList = params => {
    const { purchaseOrderId, rfsId } = this.props;

    this.props.dispatch({
      type: WorkOrderActionType.GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_ASYNC,
      params: {
        data: {
          searchKey: '',
          skip: 0,
          take: 50,
          ...params
        },
        refNo: purchaseOrderId,
        rfsId
      }
    });
  };

  customRenderPOID(item) {
    if (this.props.isPunchList) {
      return (
        <Link
          to={`/punch-lists/punch-list-item/back-charge/${this.props.match.params.RFSID}/${this.props.match.params.WOID}/${this.props.match.params.POID}/detail/${item.refNo}`}
        >
          {item.refNo}
        </Link>
      );
    }
    return (
      <Link
        to={`/request-for-services/work-order/back-charge/${this.props.match.params.RFSID}/${this.props.match.params.WOID}/${this.props.match.params.POID}/detail/${item.refNo}`}
      >
        {item.refNo}
      </Link>
    );
  }

  customRenderChargedTo(item) {
    return <span>{item.subcontractor.companyName}</span>;
  }

  customRenderTrade(item) {
    return <span>{item.trade.name}</span>;
  }

  customRenderAmount(item) {
    if (item.amount) {
      return <span>{Number(item.amount).toFixed(2)}</span>;
    }
    return <span>-</span>;
  }

  renderButtonNewBC = () => {
    if (this.props.isPunchList) {
      return (
        <div className='col-sm-6'>
          <Link
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            to={`/punch-lists/punch-list-item/back-charge/${this.props.match.params.RFSID}/${this.props.match.params.WOID}/${this.props.match.params.POID}/add`}
          >
            <span className='fa fa-plus icon' />
            NEW
          </Link>
        </div>
      );
    }
    return (
      <div className='col-sm-6'>
        <Link
          className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
          to={`/request-for-services/work-order/back-charge/${this.props.match.params.RFSID}/${this.props.match.params.WOID}/${this.props.match.params.POID}/add`}
        >
          <span className='fa fa-plus icon' />
          NEW
        </Link>
      </div>
    );
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.fetchBCList({
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder
        });
      }
    );
  }

  refreshPageList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.fetchBCList({
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder
        });
      }
    );
  }

  render() {
    const column = [
      {
        field: 'refNo',
        header: 'BC#',
        hidden: false,
        isKey: true,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderPOID.bind(this)
      },
      {
        field: 'tradeName',
        header: 'Trade',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderTrade.bind(this)
      },
      {
        field: 'subcontractor',
        header: 'Charged to',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderChargedTo.bind(this)
      },
      {
        field: 'amount',
        header: 'Amount',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderAmount.bind(this)
      },
      {
        field: 'reason',
        header: 'Reason',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left'
      }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder // default sort order,
    };

    const tableHeader = (
      <div className='table-header'>
        <div className='row'>
          <div className='col-sm-6'>
            <label>
              Back charges ({this.props.ManageBackCharges.items.length})
            </label>
          </div>
          {this.renderButtonNewBC()}
        </div>
      </div>
    );

    return (
      <div className='back-charge-wrapper col-sm-12'>
        <TableList
          column={column}
          defaultParams={defaultParams}
          data={this.props.ManageBackCharges.items}
          options={options}
          showButtonMenu={true}
          refreshPageList={this.refreshPageList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          customTableHeader={tableHeader}
          ignoreSinglePage
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ManageBackCharges: state.WorkOrderReducer.ManageBackCharges
  };
};

export default connect(mapStateToProps)(BackChargeList);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/BackChargeList.js